import { Form, Skeleton } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';
import dayjs, { Dayjs } from 'dayjs';
import DateRangePickerWithDots from 'shared/components/dateRangePickerWithDots/DateRangePickerWithDots';
import { PICKER_DATE_MASK } from 'shared/constants';

const { Item } = Form;

type IProps = RangePickerProps & { loading?: boolean };

export const DatePeriodField: React.FC<IProps> = ({ loading, disabled, ...props }) => {
  return (
    <Item
      name="period"
      label="Период"
      rules={[
        {
          required: true,
          validator: async (_, v: [Dayjs | null, Dayjs | null]) => {
            if (v.includes(null)) return Promise.reject();
          },
          message: 'Выберите период',
        },
      ]}
      required
    >
      {loading ? (
        <Skeleton.Button active block />
      ) : (
        <DateRangePickerWithDots
          disabledDate={current => current && current < dayjs().startOf('day')}
          style={{ width: '100%' }}
          format={PICKER_DATE_MASK}
          disabled={disabled}
          {...props}
        />
      )}
    </Item>
  );
};
